import { SortingQuestionPinAnswer } from '@lessonup/pins-shared';
import { Card, fontSizeMap, lineHeightMap, SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React, { PropsWithChildren } from 'react';
import { ParsedTextTipTapViewer } from '../../../../../components/Tiptap/ParsedTextTipTapViewer';

export interface SortingQuestionAnswerCardProps {
  index: number;
  answer: SortingQuestionPinAnswer;
}

export const SortingQuestionAnswerCard: React.FC<PropsWithChildren<SortingQuestionAnswerCardProps>> = ({
  index,
  answer,
  children,
}) => {
  return (
    <Card size="small" showBoxShadow resizing="fixed" autoHeight showBorder={false}>
      <SpaceBetween direction="x" spacing={spacing.size16} alignItems="center" padding={spacing.size8}>
        <StyledAnswerIndex>{index + 1}</StyledAnswerIndex>
        <StyledAnswerWrapper direction="x" spacing={spacing.size8} alignItems="center">
          {children ? children : <ParsedTextTipTapViewer content={answer.text} />}
        </StyledAnswerWrapper>
      </SpaceBetween>
    </Card>
  );
};

const StyledAnswerWrapper = styled(SpaceBetween)`
  flex: 1;
  font-size: ${fontSizeMap['bodyText'].medium};
  line-height: ${lineHeightMap['bodyText'].medium};

  // Ensure the first child (the text content) has consistent styling
  & > :first-child {
    flex: 1;
    width: 0; // prevent the content from taking up all the space it needs
    height: ${lineHeightMap['bodyText'].medium};

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
      padding: ${spacing.size0} ${spacing.size4};
    }

    &:focus-within p {
      text-overflow: clip;
    }
  }
`;

const StyledAnswerIndex = styled.span`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;
